import axios, { AxiosInstance } from 'axios';
import { localStorageManager, STORAGE_KEYS } from '../../utils/localStorage';

// API 기본 설정 - 환경에 따라 다른 URL 사용
const API_BASE_URL = 'https://prod-sol-af-tracker.alpha-filter.xyz';

// axios 인스턴스 생성
export const apiClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  timeout: 1000000, // 1000초로 연장
  headers: {
    'Content-Type': 'application/json',
  },
});

// 응답 인터셉터 - 에러 처리
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('FE Management System API Error:', error);
    throw error;
  }
);

// 공통 헤더 생성 함수
export const getAuthHeaders = () => {
  const apiKey = localStorageManager.getStringItem(STORAGE_KEYS.API_KEY);
  return {
    'X-API-Key': apiKey || '',
    'Content-Type': 'application/json',
  };
};
